import { numberWithCommas } from '../utils/numberWithCommas';

export const formatResultsData = (chosenVersion, chosenYear) => {
  const {
    priceInfo: { basicPrice, vat, deliveryPrice },
    tax: { firstTaxPayment },
    fuelType,
    bikValues,
  } = chosenVersion;
  const currentBikVal = bikValues[chosenYear];
  const listPrice = Math.round(
    parseFloat(basicPrice) + parseFloat(vat) + parseFloat(deliveryPrice),
  );
  const benefitGBP = Math.round((listPrice * currentBikVal) / 100);
  const taxPayable20 = Math.round(benefitGBP * 0.2);
  const taxPayable40 = Math.round(benefitGBP * 0.4);
  const fuelEconomy = chosenVersion['wltp-mpg-comb-min'];

  const tableData = {
    listPrice: {
      label: 'List price',
      value: `£${numberWithCommas(listPrice)}`,
    },
    co2Emissions: {
      label: 'CO2 emissions',
      value: `${chosenVersion.co2_gkm} g/km`,
    },
    fuelType: {
      label: 'Fuel Type',
      value: fuelType,
    },
    benefitPercent: {
      label: 'Benefit in kind (% charge)',
      value: `${currentBikVal}%`,
    },
    benefitGBP: {
      label: 'Benefit in kind (£)',
      value: `£${numberWithCommas(benefitGBP)}`,
    },
    taxPayable20: {
      label: 'Tax payable at 20%',
      value: `£${numberWithCommas(taxPayable20)}`,
    },
    taxPayable40: {
      label: 'Tax payable at 40%',
      value: `£${numberWithCommas(taxPayable40)}`,
    },
    fuelEconomy: fuelEconomy
      ? {
          label: 'Fuel economy',
          value: `${fuelEconomy} mpg`,
        }
      : null,
    monthsRoadTax: {
      label: '12 months road tax',
      value: `£${numberWithCommas(firstTaxPayment)}`,
    },
    insuranceGroup: {
      label: 'Insurance group',
      value: chosenVersion['insurance_group_1_50_effective_january_07'],
    },
  };

  const result = {
    tableData,
    make:
      chosenVersion?.content?.makeModels?.make?.displayName ||
      chosenVersion?.make,
    model:
      chosenVersion?.content?.makeModels?.model?.displayName ||
      chosenVersion?.range,
    version: chosenVersion?.name || chosenVersion?.content?.displayName,
    image:
      chosenVersion?.images?.urls?.mainFullsize ||
      'https://media.whatcar.com/default-images/deals_default_lg.png',
  };

  return result;
};
